import { analyticsService } from "../services/analytics.service";
import { analyticsConstants } from "../constants/analytics.constants";

export const analyticsActions = {
  getDashboardStats,
  getExecutionStats,
  getExecutionTrends,
  getApiUsage,
  getApiFailures,
  getApiRecords,
  getRunbookOverview,
  getRunbookExecutions,
  getExecutionDetail,
};

function getDashboardStats(requestParameters) {
  return (dispatch) => {
    dispatch(request());

    analyticsService.getDashboardStats(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request() {
    return { type: analyticsConstants.GET_DASHBOARD_STATS_REQUEST };
  }
  function success(response) {
    return {
      type: analyticsConstants.GET_DASHBOARD_STATS_SUCCESS,
      payload: response,
    };
  }
  function failure() {
    return { type: analyticsConstants.GET_DASHBOARD_STATS_FAILURE };
  }
}

function getExecutionStats(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    analyticsService.getExecutionStats(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: analyticsConstants.GET_EXECUTION_STATS_REQUEST,
      payload: requestParameters,
    };
  }
  function success(response) {
    return {
      type: analyticsConstants.GET_EXECUTION_STATS_SUCCESS,
      payload: response,
    };
  }
  function failure() {
    return { type: analyticsConstants.GET_EXECUTION_STATS_FAILURE };
  }
}

function getExecutionTrends(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    analyticsService.getExecutionTrends(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: analyticsConstants.GET_EXECUTION_TRENDS_REQUEST,
      payload: requestParameters,
    };
  }
  function success(response) {
    return {
      type: analyticsConstants.GET_EXECUTION_TRENDS_SUCCESS,
      payload: response,
    };
  }
  function failure() {
    return { type: analyticsConstants.GET_EXECUTION_TRENDS_FAILURE };
  }
}

function getApiUsage(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    analyticsService.getMostCalledApiSystems(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: analyticsConstants.GET_API_USAGE_REQUEST,
      payload: requestParameters,
    };
  }
  function success(response) {
    return {
      type: analyticsConstants.GET_API_USAGE_SUCCESS,
      payload: response,
    };
  }
  function failure() {
    return { type: analyticsConstants.GET_API_USAGE_FAILURE };
  }
}

function getApiFailures(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    analyticsService.getApiFailureRates(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: analyticsConstants.GET_API_FAILURES_REQUEST,
      payload: requestParameters,
    };
  }
  function success(response) {
    return {
      type: analyticsConstants.GET_API_FAILURES_SUCCESS,
      payload: response,
    };
  }
  function failure() {
    return { type: analyticsConstants.GET_API_FAILURES_FAILURE };
  }
}

function getApiRecords(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    analyticsService.getApiRecords(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: analyticsConstants.GET_API_RECORDS_REQUEST,
      payload: requestParameters,
    };
  }
  function success(response) {
    return {
      type: analyticsConstants.GET_API_RECORDS_SUCCESS,
      payload: response,
    };
  }
  function failure() {
    return { type: analyticsConstants.GET_API_RECORDS_FAILURE };
  }
}

function getRunbookOverview(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    analyticsService.getRunbookOverview(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: analyticsConstants.GET_RUNBOOK_OVERVIEW_REQUEST,
      payload: requestParameters,
    };
  }
  function success(response) {
    return {
      type: analyticsConstants.GET_RUNBOOK_OVERVIEW_SUCCESS,
      payload: response,
    };
  }
  function failure() {
    return { type: analyticsConstants.GET_RUNBOOK_OVERVIEW_FAILURE };
  }
}

// Normalizes the executions response across the cursor-paginated shape
// ({ data, nextCursor, hasMore }) and the legacy plain-array shape, so the UI
// works against both the new API and any environment still on the old endpoint.
function normalizeExecutionsPage(data) {
  if (Array.isArray(data)) {
    return { items: data, nextCursor: null, hasMore: false };
  }
  return {
    items: data?.data ?? [],
    nextCursor: data?.nextCursor ?? null,
    hasMore: data?.hasMore ?? false,
  };
}

// options.append === true appends the page (infinite scroll); otherwise it
// replaces the list (first page / filter change).
function getRunbookExecutions(requestParameters, options = {}) {
  const append = options.append === true;
  return (dispatch) => {
    dispatch(request(requestParameters, append));

    analyticsService.getRunbookExecutions(requestParameters).then(
      (response) => {
        dispatch(success(normalizeExecutionsPage(response.data), append));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters, append) {
    return {
      type: analyticsConstants.GET_RUNBOOK_EXECUTIONS_REQUEST,
      payload: requestParameters,
      append,
    };
  }
  function success(page, append) {
    return {
      type: analyticsConstants.GET_RUNBOOK_EXECUTIONS_SUCCESS,
      items: page.items,
      nextCursor: page.nextCursor,
      hasMore: page.hasMore,
      append,
    };
  }
  function failure() {
    return { type: analyticsConstants.GET_RUNBOOK_EXECUTIONS_FAILURE };
  }
}

function getExecutionDetail(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    analyticsService.getExecutionDetail(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: analyticsConstants.GET_EXECUTION_DETAIL_REQUEST,
      payload: requestParameters,
    };
  }
  function success(response) {
    return {
      type: analyticsConstants.GET_EXECUTION_DETAIL_SUCCESS,
      payload: response,
    };
  }
  function failure() {
    return { type: analyticsConstants.GET_EXECUTION_DETAIL_FAILURE };
  }
}
